module.exports = "<div id=\"wrapper\" [class.toggled]=\"menuToggled\">\r\n   <!-- Sidebar -->\r\n   <app-sidebar></app-sidebar>\r\n   <!-- /#sidebar-wrapper -->\r\n\r\n   <!-- Page Content -->\r\n   <div >\r\n       <app-header (toggled)=\"menuToggle($event)\"></app-header>\r\n       <router-outlet></router-outlet>\r\n   </div>\r\n   <!-- Page Content Ends -->\r\n </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 917
// module chunks = 20